import { render, staticRenderFns } from "./registerHead.vue?vue&type=template&id=54145c5c&scoped=true&"
import script from "./registerHead.vue?vue&type=script&lang=js&"
export * from "./registerHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54145c5c",
  null
  
)

export default component.exports